import { render, staticRenderFns } from "./GroupIdentifier.vue?vue&type=template&id=5b3227f8"
import script from "./GroupIdentifier.vue?vue&type=script&lang=js"
export * from "./GroupIdentifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports